import React from 'react';
import styled from 'styled-components';
import {
  PoolProspectCustomizeItem,
  Prospect,
  useUpdatePoolProspectCustomizeItemNameMutation,
} from 'api';
import TextItem from './Text';
import NumberItem from './Number';
import DateItem from './Date';
import SelectItem from './Select';
import {Input as UIInput} from 'components/antd';
import {HashTag, Text, Tag, Calendar} from './Icon';
import useClientUser from 'hooks/useClientUser';

const itemComponents: {[key: string]: any} = {
  text: TextItem,
  number: NumberItem,
  date: DateItem,
  select: SelectItem,
};

const itemIcons: {[key: string]: any} = {
  text: Text,
  number: HashTag,
  date: Calendar,
  select: Tag,
};

interface Props {
  prospect: Prospect;
  poolProspectCustomizeItem: PoolProspectCustomizeItem;
}

export default ({prospect, poolProspectCustomizeItem}: Props) => {
  const {isAdmin} = useClientUser();
  const ItemComponent = React.useMemo(
    () => itemComponents[poolProspectCustomizeItem.dataType],
    [poolProspectCustomizeItem],
  );

  const ItemIcon = React.useMemo(
    () => itemIcons[poolProspectCustomizeItem.dataType],
    [poolProspectCustomizeItem],
  );

  const [value, setValue] = React.useState(poolProspectCustomizeItem?.name);
  const [updateName] = useUpdatePoolProspectCustomizeItemNameMutation();

  const update = (e: any) => {
    value.trim() !== '' &&
      updateName({
        variables: {
          name: value,
          id: poolProspectCustomizeItem.id,
        },
      });
  };

  return (
    <Container>
      <ItemIcon />
      <div>
        {isAdmin ? (
          <Input
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onPressEnter={update}
            onBlur={update}
            placeholder="未入力"
            disabled={!isAdmin}
          />
        ) : (
          <Label>{value}</Label>
        )}
      </div>
      <div>
        <ItemComponent
          prospect={prospect}
          poolProspectCustomizeItem={poolProspectCustomizeItem}
        />
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: var(--text-color-1);
  min-height: 24px;
  width: 100%;

  & > div:first-child {
    width: 180px;
  }
  & > div:last-child {
    flex: 1;
  }
`;

const Input = styled(UIInput)`
  border-color: transparent;
  background-color: transparent;
  border-radius: 4px;
  width: 180px;

  &:hover {
    border: 1px solid var(--text-color-3);
  }
`;

const Label = styled.div`
  width: 180px;
  padding: 6px;
`;
